module.exports = __webpack_public_path__ + "static/media/evolving.5bda5481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PromotionCards/evolving.jpg
// module id = 815
// module chunks = 0